import React from 'react';
//Cookies
function Cookies() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      

      {/*  Page content */}
      <main className="flex-grow">

        <section className="bg-grey-900">
          <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="pt-32 pb-12 md:pt-40 md:pb-20">

              {/* Page header */}
              <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
                <h1 className="h1 mb-4 text-white">Cookie Policy</h1>
                <p className="text-xl text-white">Last updated June 16, 2021</p>
              </div>
              <h4 className="h4 mb-2 mt-2 text-white">Tracking &amp; Cookies Data</h4>
<p className="text-white">We use cookies and similar tracking technologies to track the activity on our Service and we hold certain information.</p>
<p className="text-white">Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Other tracking technologies are also used such as beacons, tags and scripts to collect and track information and to improve and analyse our Service.</p>
<p className="text-white">You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
<p className="text-white">Examples of Cookies we use:</p>
<ul>
<li className = "text-white"><strong>Session Cookies.</strong> We use Session Cookies to operate our Service.</li>
<li className = "text-white"><strong>Preference Cookies.</strong> We use Preference Cookies to remember your preferences and various settings.</li>
<li className = "text-white"><strong>Security Cookies.</strong> We use Security Cookies for security purposes.</li>
</ul>
              
              

            </div>
          </div>
        </section>

      </main>

    </div>
  );
}

export default Cookies;